var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    _vm._g(
      {
        attrs: {
          width: "auto",
          title: "View Comments",
          visible: _vm.dialogVisible,
          scrollbar: false,
        },
        on: {
          "update:visible": function ($event) {
            _vm.dialogVisible = $event
          },
          closed: _vm.onClosed,
          open: _vm.onOpen,
        },
      },
      _vm.$listeners
    ),
    [
      _c(
        "ul",
        { staticClass: "comments-list" },
        [
          _vm.loading
            ? [_c("Loading", { attrs: { color: "#d52b1e" } })]
            : [
                _vm.comments.length > 0
                  ? _vm._l(_vm.comments, function (item, i) {
                      return _c("li", { key: i, staticClass: "comment-item" }, [
                        _c("p", { staticClass: "comment-item-info" }, [
                          _c("span", [_vm._v(_vm._s(item.SEName))]),
                          _c("span", [_vm._v(_vm._s(item.CommentedOn))]),
                        ]),
                        _c("p", [_vm._v(" " + _vm._s(item.Comment) + " ")]),
                      ])
                    })
                  : _c("div", { staticClass: "empty-tips" }, [
                      _vm._v("No comment information"),
                    ]),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }